




































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import FooterLink from './FooterLink.vue'

@Component({
  components: {FooterLink},
})
export default class AccordionFooter extends Mixins(MixinScreenSize) {
  @Prop({type: String, required: true}) title!: string

  isAccordionVisible = true
  isAccordionOpened = false

  handleClickAccordion() {
    if (this.isDesktop || this.isSmallDesktop) {
      return
    }
    this.isAccordionOpened = !this.isAccordionOpened
  }
}
